import React, { useState, useEffect ,useContext} from "react";
import * as StyleDOM from "../../../../Components/Applicant-Tracking/Candidates/CandidateDetails/CandidateDocuments.jsx";
import AnimationPlayer from "../../../../Common/Animation-Player/AnimationPlayer";
import VybogTALLoaderAnimation from "../../../../Common/Dynamic-Animations/DynamicAnimations.js";
import NoHistoryAnimation from "../../../../Assets/Json/No-History-Animation.json";
import infoIcon from "../../../../Assets/Images/info-icon.png";
import JobsCard from "../../../../Common/Card/JobsCard";
import webIcon from "../../../../Assets/Images/webIcon.png";
import { get } from "../../../../helper/Api_helper";
import {
  VYLABS_BASE_URL,
  GET_JOB_LIST_BY_CLIENT,
} from "../../../../helper/url_helper";
import { DynamicContext } from "../../../../Context/DynamicContext";
const ClientJobs = ({
  clientId,
  onOpenJobDetails,
  jobsListLastElement,
  setClientJobsList,
  clientJobsList,
  isInitialLoading,
  setIsInitialLoading,
  isLoadingMore,
  setIsLoadingMore,
  clientJobsListHasMore,
  setClientJobsListHasMore,
  showLoader,
  setShowLoader,
}) => {
  const [clientJobsListOffset, setClientJobsListOffset] = useState(0);
    const { isHiringTeamTenant } = useContext(DynamicContext);
    const tenantLabel = isHiringTeamTenant ? "Hiring Team" : "Client";
  const fetchClientJobs = async (customOffset = clientJobsListOffset) => {
    try {
      if (customOffset === 0) {
        setIsInitialLoading(true);
      } else {
        setIsLoadingMore(true);
      }
      const response = await get(
        VYLABS_BASE_URL,
        `${GET_JOB_LIST_BY_CLIENT}?client_id=${clientId}&offset=${customOffset}&limit=30`,
      );
      const jobs = response?.jobs ?? [];
      const fetchedJobs = Array.isArray(jobs)
        ? jobs.filter((job) => job?.id)
        : [];

      setClientJobsList((prev) => {
        if (customOffset === 0) {
          return fetchedJobs;
        } else {
          const merged = new Map();
          (prev || []).forEach((job) => {
            if (job?.id) merged.set(job.id, job);
          });
          fetchedJobs.forEach((job) => {
            if (job?.id) merged.set(job.id, job);
          });
          return Array.from(merged.values());
        }
      });

      setClientJobsListHasMore(jobs.length === 30);
    } catch (err) {
      console.error("fetchClientJobs error:", err);
      setClientJobsList((prev) => prev || []);
    } finally {
      setIsInitialLoading(false);
      setIsLoadingMore(false);
    }
  };

  useEffect(() => {
    if (!clientId) return;
    fetchClientJobs(clientJobsListOffset);
  }, [clientJobsListOffset, clientId]);

  useEffect(() => {
    setShowLoader(true);
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, 700);
    return () => clearTimeout(timer);
  }, []);

  if (showLoader || isInitialLoading || isLoadingMore) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <VybogTALLoaderAnimation />
      </div>
    );
  }

  return (
    <div className="jobs-tab-container">
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          padding: 0,
          gap: "48px",
          marginBottom: "20px",
        }}
      >
        <div
          style={{
            height: "26px",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "20px",
            lineHeight: "26px",
            letterSpacing: "-0.01em",
            color: "--header__color",
          }}
        >
          {clientJobsList.length > 0 && <>{isHiringTeamTenant ? "Hiring Team Jobs" : "Client Jobs"}</>}
        </div>
      </div>
      {clientJobsList && clientJobsList.length > 0 ? (
        <div className="client-jobs-grid">
          {clientJobsList.map((job, index) => (
            <div
              key={job.id}
              ref={
                index === clientJobsList.length - 1 ? jobsListLastElement : null
              }
            >
              <JobsCard
                jobId={job.id}
                title={job.title}
                subTitle={job.subTitle}
                icon={webIcon}
                tags={job.tags}
                location={job.location}
                experience={job.years_experience}
                jobtype={job.job_type}
                minSalary={job.salary_max}
                maxSalary={job.salary_min}
                client={job?.client?.name}
                client_contact_person={
                  job?.client_contact
                    ? job?.client_contact?.name
                    : job?.client?.contact_person
                }
                jobRole={job?.job_role}
                actionText={true}
                isActive={job.active}
                viewJob={job.viewJob}
                assignCandidateEventHandler={(e) => {
                  e.stopPropagation();
                  onOpenJobDetails(job, index, "Assigned Candidates");
                }}
                viewJobEventHandler={(e) => {
                  e.stopPropagation();
                  onOpenJobDetails(job, index, "Job Details");
                }}
                editJobEventHandler={(e) => {
                  e.stopPropagation();
                  onOpenJobDetails(job, index, "Job Details", true);
                }}
              />
            </div>
          ))}
        </div>
      ) : (
        <>
          <StyleDOM.HistoryInfoText className="history-info">
            <img
              src={infoIcon}
              alt="infoIcon"
              style={{ width: "24px", height: "24px" }}
            />
            <StyleDOM.HistoryInfoText className="history-info-text">
              No jobs have been created for this {tenantLabel} yet. Create a new job to
              start recruiting candidates for this client
            </StyleDOM.HistoryInfoText>
          </StyleDOM.HistoryInfoText>
          <StyleDOM.NoTrackingHistory className="no-tracking-history">
            <AnimationPlayer
              animationSrc={NoHistoryAnimation}
              playerHeight="200px"
              playerWidth="300px"
            />
          </StyleDOM.NoTrackingHistory>
        </>
      )}
    </div>
  );
};

export default ClientJobs;
